import { render } from "./RecurrenceListPlaceholder.vue?vue&type=template&id=7dc921a8&scoped=true"
import script from "./RecurrenceListPlaceholder.vue?vue&type=script&lang=js"
export * from "./RecurrenceListPlaceholder.vue?vue&type=script&lang=js"

import "./RecurrenceListPlaceholder.vue?vue&type=style&index=0&id=7dc921a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dc921a8"

export default script